<div class="content-card fixed">
  <div class="card-toolbar">
    <div class="card-action-buttons">
      <pa-button 
        icon="pi pi-arrow-left"
        variant="outlined" 
        size="small"
        severity="secondary"
        (click)="close()"
      ></pa-button>
    </div>
    <div class="card-title">
      Чат с поддержкой
    </div>
  </div>
  <div class="card-container">
    <div id='tawk_68639f2689d0b51907b13c63'></div>
    <div id="spinner">
      <ion-spinner></ion-spinner>
    </div>
  </div>
</div>